import React from 'react';

import StorableSearchInput from 'samples/storables/StorableSearchInput';
import {Operator, SingleValueFilter} from 'search/SearchConstants';

import {BaseFilterFormProps, FilterStyle} from './base/FilterFormConstants';
import {ItemSearchSingleValueFilterForm} from './ItemSearchFilterForm';

interface AncestorStorableFilterFormProps extends BaseFilterFormProps {
  filter: SingleValueFilter;
  filterStyle: FilterStyle;
  onChangeFilter: (filter: SingleValueFilter) => void;
  onEnter?: () => void;
  onRemove?: () => void;
  operators: Array<Operator>;
}

const AncestorStorableFilterForm: React.SFC<AncestorStorableFilterFormProps> = (
  props: AncestorStorableFilterFormProps
): JSX.Element => <ItemSearchSingleValueFilterForm {...props} itemSearchInputClass={StorableSearchInput} />;

export default AncestorStorableFilterForm;
